import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import ItemCard from "../components/ItemCard";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHouse, faWallet, faSackDollar, faBolt, faClock, faCoins, faUser, faCalendarDays, faCircle, faHeadset, faPlus, faCircleNotch, faXmark, faMagnifyingGlass, faFilter, faGear, faDotCircle, faChartLine,faHandHoldingUsd, faFire } from '@fortawesome/free-solid-svg-icons'
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons'
import { Link } from "react-router-dom"
import { useUser } from "../utils/UserContext";
import { getCurrencySymbol, formatCurrency, getRate, formatLargeNumber } from '../utils/currencyUtils';
import { Toaster, toast } from 'react-hot-toast';
import EmailVerifyModal from "../components/EmailVerifyModal";
import 'react-multi-carousel/lib/styles.css';
import Line from "../components/chart/Line";
import feather from 'feather-icons';
import ConnectBar from "../components/ConnectBar";
import Ticker from "../components/Ticker";
import AssetList from "../components/AssetList";
import logo from "../images/brand/logo.png";
import Carousel from 'react-multi-carousel';
import Modal from 'react-modal';

function Dashboard() {
  useEffect(() => {
    feather.replace();
  }, []);
  const { user } = useUser();
  //CLEAR LOCAL Storage
  localStorage.clear();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
      const r = await getRate(currencyCode);
      if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [see, setSee] = useState(true);
  const [walletTab, setWalletTab] = useState("accountinfo");
  const [usdbal, setUsdbal] = useState(0);
  const [btcBal, setBtcBal] = useState(0);
  const [ethBal, setEthBal] = useState(0);
  const [usdtBal, setUsdtBal] = useState(0);
  const [otherBal, setOtherBal] = useState(0);
  //WALET CARD
  const [crypto, setCrypto] = useState([]);
  const [newCrypto, setNewCrypto] = useState([]);
  const [fiat, setFiat] = useState([]);
  const [stock, setStock] = useState([]);
  const [wallet, setWallet] = useState([]);
  const [assethistory, setAssethistory] = useState([]);
  const [sideAssets, setSideAssets] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchwallet: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setWallet(data.wallet);
      }
    })
    .catch(err => {
    })
  }, [user]);
  useEffect(() => {
      fetch(`/coin_list.txt`)
      .then((res) => res.json())
      .then((data) => {
      var coinList = data.data;
      const updatedData = coinList.map((coin, index) => ({
          id: index + 1,
          logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
          name: coin.name,
          type: 'crypto',
          symbol: coin.symbol,
          price: Number(coin.quote.USD.price.toFixed(2)),
          percentage: Number(coin.quote.USD.percent_change_24h.toFixed(2)),
          amount: 0,
      }));
      setCrypto(updatedData);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
      fetch(`/new_coin.txt`)
      .then((res) => res.json())
      .then((data) => {
      var coinList = data.data;
      const updatedData = coinList.map((coin, index) => ({
          id: index + 1,
          coin_id: coin.id,
          logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
          name: coin.name,
          type: 'crypto',
          symbol: coin.symbol,
          price: Number(coin.quote.USD.price.toFixed(2)),
          percent: Number(coin.quote.USD.percent_change_24h.toFixed(2)),
          circulating_supply: coin.circulating_supply,
          volume: coin.quote.USD.volume_24h,
          market_cap: coin.quote.USD.market_cap,
          amount: 0,
          platform: coin.platform && coin.platform.id ? `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.platform.id}.png` : `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`
      }));
      setNewCrypto(updatedData);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    fetch(`/stock_list.txt`)
    .then((res) => res.json())
    .then((data) => {
    const stockList = Object.values(data);
    const updatedData = stockList.map((stock, index) => ({
        id: index + 1,
        logo: `https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`,
        name: stock.name,
        type: 'stock',
        symbol: stock.symbol,
        price: Number(stock.price.toFixed(2)),
        amount: 0,
    }));
    setStock(updatedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {   
      fetch(`/fiat_list.txt`)
      .then((res) => res.json())
      .then((data) => {
        const wantedCurrencies = {
          AUD: 'Australian Dollar',
          CAD: 'Canadian Dollar',
          CHF: 'Swiss Franc',
          CNY: 'Chinese Yuan',
          EUR: 'Euro',
          GBP: 'British Pound',
          INR: 'Indian Rupee',
          JPY: 'Japanese Yen',
          RUB: 'Russian Ruble',
          USD: 'US Dollar',
          ZAR: 'South African Rand'
        };
        const fiatList = Object.entries(data)
          .filter(([code]) => wantedCurrencies.hasOwnProperty(code))
          .map(([code, value], index) => ({
            id: index + 1,
            symbol: code,
            name: wantedCurrencies[code],
            price: Number(value),
            type: 'fiat',
            logo: `https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`,
            amount: 0,
          }));
        
        setFiat(fiatList);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    if (!crypto.length && !fiat.length && !stock.length) return;
    const walletMap = wallet.reduce((acc, item) => {
      const key = item.coinName?.trim();
      acc[key] = parseFloat(item.balance) || 0;
      return acc;
    }, {});
    const applyWalletBalance = (list) => {
      let categorySum = 0;
      const result = list.map(item => {
        const key = item.name?.trim();
        const matchedBalance = walletMap[key];
        const amount = matchedBalance || 0;
        const value = amount * item.price;
        categorySum += value;
        return {
          ...item,
          amount
        };
      });
      return { result, categorySum };
    };
    const { result: cryptoWithBalance, categorySum: cryptoSum } = applyWalletBalance(crypto);
    const { result: fiatWithBalance, categorySum: fiatSum } = applyWalletBalance(fiat);
    const { result: stockWithBalance, categorySum: stockSum } = applyWalletBalance(stock);
    const btcPrice = crypto.find(c => c.symbol === 'BTC')?.price || 0;
    const ethPrice = crypto.find(c => c.symbol === 'ETH')?.price || 0;
    const usdtPrice = crypto.find(c => c.symbol === 'USDT')?.price || 0;
    const btcValue = (walletMap['Bitcoin'] || 0) * btcPrice;
    const ethValue = (walletMap['Ethereum'] || 0) * ethPrice;
    const usdtValue = (walletMap['Tether USDt'] || 0) * usdtPrice;
    setBtcBal(btcValue);
    setEthBal(ethValue);
    setUsdtBal(usdtValue);
    const total = cryptoSum + fiatSum + stockSum;
    setUsdbal(total);
    setOtherBal(cryptoSum - btcValue - ethValue - usdtValue);
    const merged = [
      ...cryptoWithBalance,
      ...fiatWithBalance,
      ...stockWithBalance
    ];
    const sorted = merged.sort((a, b) => {
      if (b.amount > 0 && a.amount === 0) return 1;
      if (a.amount > 0 && b.amount === 0) return -1;
      return a.name.localeCompare(b.name);
    });
    setAssethistory(sorted);

    const assetsArray = JSON.parse(user.assets);
    if (Array.isArray(assetsArray)) {
      const filteredAssets = sorted.filter(asset => 
        assetsArray.includes(asset.name?.trim())
      );
      setSideAssets(filteredAssets);
    }
  }, [crypto, fiat, stock, wallet, user]);
  const [stakes, setStakes] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchStakes: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setStakes(data.stakes);
      }
    })
    .catch(err => {
        console.error('Error fetching stakes!')
    })
  }, [user]);
  const [connectBar, setConnectBar] = useState(false);
  const toggleConnectBar = () => {
    setConnectBar(!connectBar);
  };
  const [newList, setNewList] = useState([]);
  useEffect(() => {
    fetch(`/apixxx_market.txt`)
      .then((res) => res.json())
      .then((data) => {
        var newsList = data.articles.results;
        var englishNews = newsList.filter(item => item.lang === "eng");
        const updatedData = englishNews.map((item, index) => ({
          id: index + 1,
          image: item.image ? item.image : './uploads/bg-profile.png',
          date: item.date,
          title: item.title,
          source_name: item.source?.title || "Unknown",
          language: item.lang,
        }));
        setNewList(updatedData.slice(0, 4));
      })
      .catch((err) => console.error("Error loading news:", err));
  }, []);
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1273 },
      items: 1
    },
    desktop: {
      breakpoint: { max: 1273, min: 1024 },
      items: 1
    },
    tablet: {
      breakpoint: { max: 1000, min: 740 },
      items: 1
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };
  const responsivemulti = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1273 },
      items: 4
    },
    tablet: {
      breakpoint: { max: 1270, min: 923 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 923, min: 630 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 630, min: 0 },
      items: 1
    }
  };
  const [modalIsOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const AddAsset = () =>{
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/market.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ addasset: true, assets : sideAssets })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setLoading(false);
        setIsOpen(false);
        toast.success(data.result);
      }else{
        toast.error(data.message);
        setLoading(false);
      }
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
    })
  }
  const [trending, setTrending] = useState(6);

  const [coinListSearch, setCoinListSearch] = useState('');
  const getKey = (c) => (c?.symbol ?? c?.id ?? '').toString().toUpperCase();
  const sideKeys = new Set(
    (sideAssets || []).map(item => {
      if (typeof item === 'string') return item.toString().toUpperCase();
      return getKey(item);
    })
  );
  const getText = (c) => [
    c?.symbol?.toString() ?? '',
    c?.name?.toString() ?? '',
    c?.id?.toString() ?? '',
  ].join(' ').toLowerCase();
  const filtered = (assethistory || []).filter((c) => {
    const q = coinListSearch.trim().toLowerCase();
    if (!q) return true;
    return getText(c).includes(q);
  });
  const sortedCoins = [...filtered].sort((a, b) => {
    const aIn = sideKeys.has(getKey(a));
    const bIn = sideKeys.has(getKey(b));
    if (aIn !== bIn) return aIn ? -1 : 1;
    const aLabel = (a.symbol || a.name || '').toString().toLowerCase();
    const bLabel = (b.symbol || b.name || '').toString().toLowerCase();
    return aLabel.localeCompare(bLabel);
  });
  const [orderHistory, setOrderHistory] = useState([]);  
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/futures.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchfuturestrade: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        const orderHistory = [];
        data.trades.forEach(trade => {
          if (trade.status === "open") {
          } else if(trade.status === "position") {
          }else{
            orderHistory.push(trade);
          }
        });
        setOrderHistory(orderHistory);
      }else{
        toast.error(data.message);
      }
    })
    .catch(err => {
    })
  }, [user]);   
  return (
    <div className="container-fluid">
      <div className="row g-0">
        <div><Toaster/></div>
        <EmailVerifyModal UserDetails={user} />
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Dashboard" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Dashboard" icon={<FontAwesomeIcon icon={faHouse} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main className="mb-4">
            <div className="row">
              <div className="col-lg-8 col-md-7 col-12">
                <div className="row">
                  <div className="col-xxl-5 col-lg-6">
                    <div className="row">
                      <div className="col-10">
                        <div className="carousel-container mt-2" style={{maxWidth: '1100px'}}>
                          <Carousel responsive={responsive} swipeable={true} draggable={true} showDots={false} ssr={true} arrows={false} infinite={true} autoPlay={true} autoPlaySpeed={5000} keyBoardControl={true} containerClass="carousel-container" removeArrowOnDeviceType={["tablet", "mobile", "desktop"]}>
                            <div className="mycard">
                              <div className="d-flex align-items-center justify-content-between mb-3">
                                <p className="mb-0 fw-semibold"><FontAwesomeIcon icon={faWallet} style={{fontSize: '14px'}} className="me-1" /> Balance</p>
                                <p className="mb-0 fw-semibold">{user?.currency}</p>
                              </div>
                              <div className="d-flex align-items-center mb-3">
                                <h3 className="fw-bold mb-0 me-3">{see ? `${getCurrencySymbol(user?.currency)}${formatCurrency(usdbal * rate)}` : '******'}</h3>
                                <FontAwesomeIcon icon={(see === true)?faEye:faEyeSlash} className="text-secondary" style={{fontSize: '14px'}} onClick={() => { setSee(see === true ? false : true);}}/>
                              </div>
                              <div className="progress" style={{ height: "6px", backgroundColor: 'rgba(0, 0, 0, 0.2)'}}>
                                <div 
                                  className="progress-bar" 
                                  style={{ 
                                    width: `${usdbal ? Math.max(((btcBal / usdbal) * 100).toFixed(2), 10) : 10}%`, 
                                    backgroundColor: 'rgba(255, 145, 0, 1)' 
                                  }} 
                                />
                                <div 
                                  className="progress-bar" 
                                  style={{ 
                                    width: `${usdbal ? Math.max(((ethBal / usdbal) * 100).toFixed(2), 10) : 10}%`, 
                                    backgroundColor: 'rgba(31, 31, 31, 1)' 
                                  }} 
                                />
                                <div 
                                  className="progress-bar" 
                                  style={{ 
                                    width: `${usdbal ? Math.max(((usdtBal / usdbal) * 100).toFixed(2), 10) : 10}%`, 
                                    backgroundColor: 'rgba(0, 138, 138, 1)' 
                                  }} 
                                />
                                <div 
                                  className="progress-bar" 
                                  style={{ 
                                    width: `${usdbal ? Math.max(((otherBal / usdbal) * 100).toFixed(2), 10) : 10}%`, 
                                    backgroundColor: 'rgb(66, 84, 251)' 
                                  }} 
                                />
                              </div>
                              <div className="d-flex align-items-center justify-content-between mt-1">
                                <div className="d-flex align-items-center">
                                  <img src="https://s2.coinmarketcap.com/static/img/coins/64x64/1.png" alt="logo" style={{height:'13px'}}/>
                                  <p className="mb-0 ms-1" style={{fontSize:'12px'}}>BTC</p>
                                </div>
                                <div className="d-flex align-items-center">
                                  <img src="https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png" alt="logo" style={{height:'13px'}}/>
                                  <p className="mb-0 ms-1" style={{fontSize:'12px'}}>ETH</p>
                                </div>
                                <div className="d-flex align-items-center">
                                  <img src="https://s2.coinmarketcap.com/static/img/coins/64x64/825.png" alt="logo" style={{height:'13px'}}/>
                                  <p className="mb-0 ms-1" style={{fontSize:'12px'}}>USDT</p>
                                </div>
                                <p className="mb-0 ms-1" style={{fontSize:'12px'}}>Others</p>
                              </div>
                              <div className="d-flex align-items-end justify-content-between mt-2">
                                <div>
                                  <p className="mb-0" style={{fontSize:'14px'}}>Profit (All)</p>
                                  <p className="fw-semibold text-success mb-0">+{getCurrencySymbol(user?.currency)}{formatCurrency(user?.profit * rate)}</p>
                                </div>
                                <p className="fw-semibold text-success mb-0">+{Number( user?.total_deposit > 0 ? (user?.profit/user?.total_deposit) * 100 : 0).toFixed(2)}%</p>
                              </div>
                            </div>
                            {sideAssets.map((sideasset) => (
                            <div className="mycard">
                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <p className="mb-0 fw-semibold"><img src={sideasset.logo} alt="logo" style={{height:'16px'}} className="me-1"/> {sideasset.name}</p>
                                <p className="mb-0 fw-semibold">{user?.currency}</p>
                              </div>
                              <div className="d-flex align-items-start justify-content-between mb-3">
                                <div>
                                  <h4 className="fw-bold mb-0 me-3">{see ? `${Number(sideasset.amount).toFixed(4)}` : '******'} {sideasset.symbol}</h4>
                                  <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency((Number(sideasset.amount) * Number(sideasset.price)) * rate)}</p>
                                </div>
                                <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>1 {sideasset.symbol} = {getCurrencySymbol(user?.currency)}{formatCurrency( Number(sideasset.price) * rate)}</p>
                              </div>
                              <div className="d-flex align-items-end justify-content-between">
                                <div>
                                  <p className="mb-0" style={{fontSize:'14px'}}>Profit (All)</p>
                                  <p className="fw-semibold text-success mb-0" style={{fontSize:'14px'}}>+{getCurrencySymbol(user?.currency)}{formatCurrency(user?.profit * rate)}</p>
                                </div>
                                <p className="fw-semibold text-success mb-0" style={{fontSize:'14px'}}>+{Number((user?.profit/user?.total_deposit) * 100).toFixed(2)}%</p>
                              </div>
                              <div className="d-flex align-items-center justify-content-between mt-2">
                                <Link to={`/futures?symbol=${sideasset.symbol}&tradetype=${sideasset.type}`} className="myBtn py-1 fw-semibold text-center" style={{backgroundColor:'#009cfc96',fontSize:'14px',width:'32%'}}>Swap</Link>
                                <Link to={`/futures?symbol=${sideasset.symbol}&tradetype=${sideasset.type}`} className="myBtn py-1 fw-semibold bg-success text-center" style={{fontSize:'14px',width:'32%'}}>Buy</Link>
                                <Link to={`/futures?symbol=${sideasset.symbol}&tradetype=${sideasset.type}`} className="myBtn py-1 fw-semibold bg-danger text-center" style={{fontSize:'14px',width:'32%'}}>Sell</Link>
                              </div>
                            </div>
                            ))}
                          </Carousel>
                        </div>
                      </div>
                      <div className="col-2 p-0 pe-2 pe-lg-0">
                        <div className="mycard d-flex align-items-center justify-content-center mt-2 px-0" onClick={() => setIsOpen(true)} style={{height:'222px', border:'2px dotted rgba(255, 255, 255, 0.09)', cursor: 'pointer'}}>
                          <p className="mb-0 fw-semibold" style={{fontSize: '12px'}}><FontAwesomeIcon icon={faPlus} style={{fontSize: '12px'}} /> ADD</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-7 col-lg-6">
                    <div className="carousel-container mt-2" style={{maxWidth: '1100px'}}>
                      <Carousel responsive={responsive} swipeable={true} draggable={true} showDots={false} ssr={true} infinite={true} autoPlay={true} keyBoardControl={true} containerClass="carousel-container" removeArrowOnDeviceType={["tablet", "mobile", "desktop"]}>
                        <div className="rounded-4 overflow-hidden d-flex align-items-center" style={{height:'222px'}}>
                          <img src={`./uploads/advert1.png`} alt="chart" style={{height: '100%',width:'100%', objectFit:'cover'}}/>
                        </div>
                        <div className="rounded-4 overflow-hidden d-flex align-items-center" style={{height:'222px'}}>
                          <img src={`./uploads/advert.png`} alt="chart" style={{height: '100%',width:'100%', objectFit:'cover'}}/>
                        </div>
                      </Carousel>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="mycard mt-2 p-3">
                      <p className="mb-2 fw-bold fs-5">Quick Links</p>
                      <div className="d-flex align-items-center" style={{gap:'10px', overflowX:'auto'}}>
                        <Link to="/deposit" className="mycard shadow px-0 py-2 d-flex flex-column align-items-center noLink" style={{border:'1px solid #009cfc96',cursor:'pointer',minWidth:'95px'}}>
                          <div className="d-flex align-items-center justify-content-center rounded-circle overflow-hidden" style={{backgroundColor:'#009cfc7a',height:'35px',width:'35px'}}>
                            <i data-feather="credit-card" height="18"></i>
                          </div>
                          <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Deposit</p>
                        </Link>
                        <Link to="/futures" className="mycard shadow px-0 py-2 d-flex flex-column align-items-center noLink" style={{border:'1px solid #009cfc96',cursor:'pointer',minWidth:'95px'}}>
                          <div className="d-flex align-items-center justify-content-center rounded-circle overflow-hidden" style={{backgroundColor:'#009cfc7a',height:'35px',width:'35px'}}>
                            <i data-feather="activity" height="18"></i>
                          </div>
                          <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Trade</p>
                        </Link>
                        <Link to="/copyexpert" className="mycard shadow px-0 py-2 d-flex flex-column align-items-center noLink" style={{border:'1px solid #009cfc96',cursor:'pointer',minWidth:'95px'}}>
                          <div className="d-flex align-items-center justify-content-center rounded-circle overflow-hidden" style={{backgroundColor:'#009cfc7a',height:'35px',width:'35px'}}>
                            <i data-feather="copy" height="18"></i>
                          </div>
                          <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Copy Trade</p>
                        </Link>
                        <Link to="/assets" className="mycard shadow px-0 py-2 d-flex flex-column align-items-center noLink" style={{border:'1px solid #009cfc96',cursor:'pointer',minWidth:'95px'}}>
                          <div className="d-flex align-items-center justify-content-center rounded-circle overflow-hidden" style={{backgroundColor:'#009cfc7a',height:'35px',width:'35px'}}>
                            <i data-feather="grid" height="18"></i>
                          </div>
                          <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Assets</p>
                        </Link>
                        <Link to="/withdraw" className="mycard shadow px-0 py-2 d-flex flex-column align-items-center noLink" style={{border:'1px solid #009cfc96',cursor:'pointer',minWidth:'95px'}}>
                          <div className="d-flex align-items-center justify-content-center rounded-circle overflow-hidden" style={{backgroundColor:'#009cfc7a',height:'35px',width:'35px'}}>
                            <i data-feather="package" height="18"></i>
                          </div>
                          <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Withdraw</p>
                        </Link>
                        <Link to="/signal" className="mycard shadow px-0 py-2 d-flex flex-column align-items-center noLink" style={{border:'1px solid #009cfc96',cursor:'pointer',minWidth:'95px'}}>
                          <div className="d-flex align-items-center justify-content-center rounded-circle overflow-hidden" style={{backgroundColor:'#009cfc7a',height:'35px',width:'35px'}}>
                            <i data-feather="wifi" height="18"></i>
                          </div>
                          <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Signals</p>
                        </Link>
                        <Link to="/stock" className="mycard shadow px-0 py-2 d-flex flex-column align-items-center noLink" style={{border:'1px solid #009cfc96',cursor:'pointer',minWidth:'95px'}}>
                          <div className="d-flex align-items-center justify-content-center rounded-circle overflow-hidden" style={{backgroundColor:'#009cfc7a',height:'35px',width:'35px'}}>
                            <i data-feather="layers" height="18"></i>
                          </div>
                          <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Stock</p>
                        </Link>
                        {/* {user?.account_type === "401k" && (
                        <Link to="/loan" className="mycard shadow px-0 py-2 d-flex flex-column align-items-center noLink" style={{border:'1px solid #009cfc96',cursor:'pointer',minWidth:'95px'}}>
                          <div className="d-flex align-items-center justify-content-center rounded-circle overflow-hidden" style={{backgroundColor:'#009cfc7a',height:'35px',width:'35px'}}>
                            <i data-feather="dollar-sign" height="18"></i>
                          </div>
                          <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Loan</p>
                        </Link>
                        )} */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mycard mt-2">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                      <Link to="/deposit" className="me-3 px-3 py-2 d-flex align-items-center rounded-2" style={{backgroundColor: '#ffffff06',textDecoration:'none'}}>
                        <FontAwesomeIcon className="text-prime lh-1 me-2" icon={faBolt} style={{fontSize:'14px'}} />
                        <p className="mb-0 fw-semibold text-prime" style={{fontSize: '14px'}}>Deposit now</p>
                      </Link>
                      <div className="blockTab">
                        <div className={`blockTab-item ${walletTab === "accountinfo" ? 'active' : ''}`} onClick={() => {
                        setWalletTab("accountinfo")}}><FontAwesomeIcon icon={faSackDollar} style={{fontSize: '15px'}}/></div>
                        <div className={`blockTab-item ${walletTab === "wallet" ? 'active' : ''}`} onClick={() => {
                        setWalletTab("wallet")}}><FontAwesomeIcon icon={faWallet} style={{fontSize: '15px'}}/></div>
                      </div>
                    </div>
                  </div>
                  {walletTab === "wallet" && (
                    <div className="mt-4">
                      <div className="d-flex justify-content-between align-items-center">
                        <p className="mb-0 fw-bold text-white">Top Assets</p>
                        <Link to="/assets" className="fw-bold text-decoration-none text-prime" style={{fontSize: '15px'}}>View all assets</Link>
                      </div>
                      <div className="row">
                        {assethistory.map((asset) => asset.symbol === "BTC" && (
                          <ItemCard icon={<img src={asset.logo} alt={asset.name} style={{width: '30px'}} className="shadow-lg"/>} name={asset.name} symbol={asset.symbol} bal={asset.amount.toFixed(6)} balusd={formatCurrency((asset.price * asset.amount) * rate)} currency={getCurrencySymbol(user?.currency)}/>
                        ))}
                        {assethistory.map((asset) => asset.symbol === "ETH" && (
                          <ItemCard icon={<img src={asset.logo} alt={asset.name} style={{width: '30px'}} className="shadow-lg"/>} name={asset.name} symbol={asset.symbol} bal={asset.amount.toFixed(6)} balusd={formatCurrency((asset.price * asset.amount) * rate)} currency={getCurrencySymbol(user?.currency)}/>
                        ))}
                        {assethistory.map((asset) => asset.symbol === "USDT" && (
                          <ItemCard icon={<img src={asset.logo} alt={asset.name} style={{width: '30px'}} className="shadow-lg"/>} name={asset.name} symbol={asset.symbol} bal={asset.amount.toFixed(6)} balusd={formatCurrency((asset.price * asset.amount) * rate)} currency={getCurrencySymbol(user?.currency)}/>
                        ))}
                        {assethistory.map((asset) => asset.symbol === "USD" && (
                          <ItemCard icon={<img src={asset.logo} alt={asset.name} style={{width: '32px'}} className="shadow-lg"/>} name={asset.name} symbol={asset.symbol} bal={asset.amount.toFixed(6)} balusd={formatCurrency((asset.price * asset.amount) * rate)} currency={getCurrencySymbol(user?.currency)}/>
                        ))}
                        {assethistory.map((asset) => asset.symbol === "GBP" && (
                          <ItemCard icon={<img src={asset.logo} alt={asset.name} style={{width: '32px'}} className="shadow-lg"/>} name={asset.name} symbol={asset.symbol} bal={asset.amount.toFixed(6)} balusd={formatCurrency((asset.price * asset.amount) * rate)} currency={getCurrencySymbol(user?.currency)}/>
                        ))}
                        {assethistory.map((asset) => asset.symbol === "EURO" && (
                          <ItemCard icon={<img src={asset.logo} alt={asset.name} style={{width: '32px'}} className="shadow-lg"/>} name={asset.name} symbol={asset.symbol} bal={asset.amount.toFixed(6)} balusd={formatCurrency((asset.price * asset.amount) * rate)} currency={getCurrencySymbol(user?.currency)}/>
                        ))}
                        {assethistory.map((asset) => asset.symbol === "GOOG" && (
                          <ItemCard icon={<img src={asset.logo} alt={asset.name} style={{width: '32px'}} className="shadow-lg"/>} name={asset.name} symbol={asset.symbol} bal={asset.amount.toFixed(6)} balusd={formatCurrency((asset.price * asset.amount) * rate)} currency={getCurrencySymbol(user?.currency)}/>
                        ))}
                        {assethistory.map((asset) => asset.symbol === "AMZN" && (
                          <ItemCard icon={<img src={asset.logo} alt={asset.name} style={{width: '32px'}} className="shadow-lg"/>} name={asset.name} symbol={asset.symbol} bal={asset.amount.toFixed(6)} balusd={formatCurrency((asset.price * asset.amount) * rate)} currency={getCurrencySymbol(user?.currency)}/>
                        ))}
                      </div>
                    </div>
                  )}
                  {walletTab === "accountinfo" && (
                    <div className="row">
                      <div className="col-lg-6 col-12 g-4">
                        <div className="shadow px-3 py-4 position-relative overflow-hidden" style={{backgroundColor: '#ffffff0d', borderLeft:'2px solid #ff6b35'}}>
                          <img src={require(`../images/map_1.png`)} alt="chart" className="position-absolute" style={{height:'400px', right:'-15%', top:'-15%',zIndex:'1'}}/>
                          <div className="position-relative" style={{zIndex:'2'}}>
                            <p className="mb-2">Account Balance</p>
                            <div className="d-xxl-flex align-items-end mb-5" style={{gap:'40px'}}>
                              <div>
                                <h3 className="mb-0 fw-semibold text-prime">{formatCurrency(user?.balance)} <span className="mb-0 text-white fs-5">USD</span></h3>
                                <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>United State Dollar Balance</p>
                              </div>
                              <div className="mt-3 mt-xxl-0">
                                <h4 className="mb-0 fw-semibold">{formatCurrency(user?.bonus)} <span className="mb-0 text-white fs-6">USD</span></h4>
                                <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>Referral Balance</p>
                              </div>
                            </div>
                            <Link to="/copyexpert" className="rounded bg-prime mb-0 px-4 fw-semibold" style={{textDecoration:'none',fontSize: '14px',paddingTop:'14px',paddingBottom:'14px'}}>Copy Experts
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-12 g-4">
                        <Carousel responsive={responsive} swipeable={true} draggable={true} showDots={false} ssr={true} infinite={true} autoPlay={true} keyBoardControl={true} containerClass="carousel-container" removeArrowOnDeviceType={["tablet", "mobile", "desktop"]}>
                          <div className="shadow px-3 pt-4 pb-2 position-relative overflow-hidden" style={{backgroundColor: '#ffffff0d', borderLeft:'2px solid #ff6b35'}}>
                            <img src={require(`../images/map_1.png`)} alt="chart" className="position-absolute" style={{height:'400px', right:'-15%', top:'-15%',zIndex:'1'}}/>
                            <div className="position-relative" style={{zIndex:'2'}}>
                              <p className="mb-2">Trading Portfolio</p>
                              <div className="d-flex align-items-end flex-wrap mb-3" style={{gap:'40px'}}>
                                <div>
                                  <h3 className="mb-0 fw-semibold text-prime">{formatCurrency(user?.airdrop * rate)} <span className="mb-0 text-white fs-5">{user?.currency}</span></h3>
                                  <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>Free Airdrops</p>
                                </div>
                                <div>
                                  <h3 className="mb-0 fw-semibold text-prime text-center">{user?.total_trade}</h3>
                                  <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>Total Trades</p>
                                </div>
                                <div>
                                  <h3 className="mb-0 fw-semibold text-prime text-center">{user?.total_won}</h3>
                                  <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>Total Won</p>
                                </div>
                                <div>
                                  <h3 className="mb-0 fw-semibold text-prime text-center">{user?.total_loss}</h3>
                                  <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>Total Loss</p>
                                </div>
                              </div>
                              <div className="d-lg-none d-xxl-block">
                                <Line height={70}/>
                              </div>
                            </div>
                          </div>
                          {orderHistory.length > 0 && orderHistory.map((trade, index) => {
                            // PUT THE CODE HERE - inside the map function
                            const baseCoin = trade.coin_id;
                            const tradeasset = crypto.find(item => item.coin_id == baseCoin);
                            return (
                              <div className="position-relative mycard p-3 overflow-hidden">
                                <div className="d-flex align-items-center justify-content-between">
                                    <img src={logo} alt="logo" className="app-logo mb-0" style={{height: '18px'}} />
                                </div>
                                <div className="ms-2">
                                    <p className="mb-0 fw-bold text-uppercase" style={{lineHeight: '100%', fontSize:'22px'}}>Futures</p>
                                    <div className="d-flex align-items-center mt-2" style={{gap:'8px'}}>
                                        <p className={`mb-0 fw-semibold ${trade.side == "Long"?'text-success':'text-danger'}`} style={{fontSize:'14px'}}>{trade.side}</p>
                                        <div style={{width:'1px',height:'20px',backgroundColor:'rgb(255 255 255 / 30%)'}}></div>
                                        <p className={`mb-0 fw-semibold`} style={{fontSize:'14px'}}>{trade.leverage}x</p>
                                        <div style={{width:'1px',height:'20px',backgroundColor:'rgb(255 255 255 / 30%)'}}></div>
                                        <p className={`mb-0 fw-semibold`} style={{fontSize:'14px'}}>{trade.pair}USDT {trade.future_type}</p>
                                    </div>
                                    <p
                                      className={`mb-0 fw-bold text-uppercase ${
                                        ((Number(trade.pandl) / Number(trade.amount)) * 100) >= 0
                                          ? "text-success"
                                          : "text-danger"
                                      }`}
                                      style={{ fontSize: "30px" }}
                                    >
                                      {((Number(trade.pandl) / Number(trade.amount)) * 100) >= 0
                                        ? "+ "
                                        : "- "}
                                      {formatCurrency(
                                        Math.abs(
                                          Number(trade.amount)
                                            ? (Number(trade.pandl) / Number(trade.amount)) * 100
                                            : 0
                                        )
                                      )}
                                      %
                                    </p>
                                    <div className="d-flex align-items-center mt-2">
                                        <p className="mb-0" style={{minWidth:'30%'}}>Entry Price</p>
                                        <p className="mb-0 text-prime">{formatCurrency(trade.price)}</p>
                                    </div>
                                    <div className="d-flex align-items-center mt-1">
                                        <p className="mb-0" style={{minWidth:'30%'}}>Last Price</p>
                                        <p className="mb-0 text-prime">{formatCurrency(trade.current_price)}</p>
                                    </div>
                                </div>
                                <img src="/uploads/Trading-in-Bull-Market-1-removebg-preview.png" alt="logo" className="position-absolute" style={{bottom:'10%', right:'-10%', width:'150px',opacity:'0.1'}}/>
                              </div>
                            );
                          })}
                        </Carousel>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-4 col-md-5 col-12">
                <div className="mycard mt-2" style={{background: 'linear-gradient(to top, #ff6b3521 5%, #ffffff06 95%)'}}>
                  <div className="carousel-container mt-2" style={{maxWidth: '1100px'}}>
                    <Carousel responsive={responsive} swipeable={true} draggable={true} showDots={false} ssr={true} arrows={false} infinite={true} autoPlay={true} autoPlaySpeed={2000} keyBoardControl={true} containerClass="carousel-container" removeArrowOnDeviceType={["tablet", "mobile", "desktop"]}>
                      <div>
                        <div className="d-flex align-items-center justify-content-between">
                          <img src={logo} alt="logo" className="app-logo"/>
                          <span className="rounded-3 fw-semibold px-2 py-1 bg-prime" style={{fontSize:'14px'}}>New</span>
                        </div>
                        <h2 className="fw-normal mt-4">Liquid Staking Portfolio</h2>
                        <p className="text-secondary fw-semibold mb-0 pb-xxl-5">An all-in-one porfolio that helps you make smarter investments into Ethereum Liquid Staking</p>
                        <div className="rounded-3 bg-prime mb-0 px-4 fw-semibold mt-5 text-center" style={{textDecoration:'none',paddingTop:'14px',paddingBottom:'14px',cursor:'pointer'}} onClick={() => {toggleConnectBar()}}>Connect with Wallet <FontAwesomeIcon className="ms-2 text-white" icon={faWallet} /></div>
                        <Link to="/stake" className="rounded-3 mb-0 px-4 fw-semibold mt-2 text-center stake-button d-block mt-3" style={{textDecoration:'none',paddingTop:'14px',paddingBottom:'14px',cursor:'pointer'}} onClick={() => {toggleConnectBar()}}>Start Staking Today <FontAwesomeIcon className="ms-2 text-white" icon={faCoins} /></Link>
                      </div>
                      {/* {user?.account_type === "401k" && (
                      <div>
                        <div className="d-flex align-items-center justify-content-between">
                          <img src={logo} alt="logo" className="app-logo"/>
                          <span className="rounded-3 fw-semibold px-2 py-1 bg-prime" style={{fontSize:'14px'}}>Secure</span>
                        </div>
                        <h2 className="fw-normal mt-4">Retirement Savings</h2>
                        <p className="text-secondary fw-semibold mb-0 pb-xxl-5">Plan for your future with a stable and diversified savings strategy for long-term financial security.</p>
                        <div className="rounded-3 bg-prime mb-0 px-4 fw-semibold mt-5 text-center" style={{textDecoration:'none',paddingTop:'14px',paddingBottom:'14px',cursor:'pointer'}} onClick={() => {toggleConnectBar()}}>Connect with Wallet <FontAwesomeIcon className="ms-2 text-white" icon={faWallet} /></div>
                        <Link to="/manager" className="rounded-3 mb-0 px-4 fw-semibold mt-2 text-center stake-button d-block mt-3" style={{textDecoration:'none',paddingTop:'14px',paddingBottom:'14px',cursor:'pointer'}} onClick={() => {toggleConnectBar()}}>Start Saving <FontAwesomeIcon className="ms-2 text-white" icon={faSackDollar} /></Link>
                      </div>
                      )} */}
                      {/* {user?.account_type === "401k" && (
                      <div>
                        <div className="d-flex align-items-center justify-content-between">
                          <img src={logo} alt="logo" className="app-logo"/>
                          <span className="rounded-3 fw-semibold px-2 py-1 bg-prime" style={{fontSize:'14px'}}>Flexible</span>
                        </div>
                        <h2 className="fw-normal mt-4">Loan Services</h2>
                        <p className="text-secondary fw-semibold mb-0 pb-xxl-5">Access quick and affordable crypto-backed or traditional loans to fit your personal and business needs.</p>
                        <div className="rounded-3 bg-prime mb-0 px-4 fw-semibold mt-5 text-center" style={{textDecoration:'none',paddingTop:'14px',paddingBottom:'14px',cursor:'pointer'}} onClick={() => {toggleConnectBar()}}>Connect with Wallet <FontAwesomeIcon className="ms-2 text-white" icon={faWallet} /></div>
                        <Link to="/loan" className="rounded-3 mb-0 px-4 fw-semibold mt-2 text-center stake-button d-block mt-3" style={{textDecoration:'none',paddingTop:'14px',paddingBottom:'14px',cursor:'pointer'}} onClick={() => {toggleConnectBar()}}>Apply for a Loan <FontAwesomeIcon className="ms-2 text-white" icon={faHandHoldingUsd} /></Link>
                      </div>
                      )} */}
                      <div>
                        <div className="d-flex align-items-center justify-content-between">
                          <img src={logo} alt="logo" className="app-logo"/>
                          <span className="rounded-3 fw-semibold px-2 py-1 bg-prime" style={{fontSize:'14px'}}>Trending</span>
                        </div>
                        <h2 className="fw-normal mt-4">Stock Investments</h2>
                        <p className="text-secondary fw-semibold mb-0 pb-xxl-5">Diversify your portfolio by investing in leading companies and trending global stocks.</p>
                        <div className="rounded-3 bg-prime mb-0 px-4 fw-semibold mt-5 text-center" style={{textDecoration:'none',paddingTop:'14px',paddingBottom:'14px',cursor:'pointer'}} onClick={() => {toggleConnectBar()}}>Connect with Wallet <FontAwesomeIcon className="ms-2 text-white" icon={faWallet} /></div>
                        <Link to="/stock" className="rounded-3 mb-0 px-4 fw-semibold mt-2 text-center stake-button d-block mt-3" style={{textDecoration:'none',paddingTop:'14px',paddingBottom:'14px',cursor:'pointer'}} onClick={() => {toggleConnectBar()}}>Trade Stocks <FontAwesomeIcon className="ms-2 text-white" icon={faChartLine} /></Link>
                      </div>
                    </Carousel>
                  </div>
                </div>
                <div className="mycard shadow p-3 mt-2 position-relative" style={{border:'1px solid #ffffff17'}}>
                  <div style={{width:'70%'}}>
                    <h4 className="mb-4 fw-bold">Looking For a Partnership With Eaglescreener?</h4>
                    <p className="text-secondary mb-4">If You're Searching For A Collaboration That Revolves Around</p>
                    <h4 className="mb-0 fw-bold">Need Help?</h4>
                    <p className="mb-0 text-prime mt-2" style={{fontSize:'14px'}}><FontAwesomeIcon className="text-prime me-1" icon={faHeadset} /> Contact our Support</p>
                  </div>
                  <img src="./uploads/partner.png" alt="image" className="position-absolute" style={{width:'32%', bottom:'20px', right:'20px'}}/>
                </div>
              </div>
              <div className="col-12">
                <div className="mt-2">
                  <Ticker crypto={crypto} pauseOnHover />
                </div>
              </div>
              <div className="col-12">
                <div className="carousel-container mt-2" style={{maxWidth: '1600px'}}>
                    <Carousel responsive={responsivemulti} swipeable={true} draggable={true} showDots={false} ssr={true} infinite={true} autoPlay={true} keyBoardControl={true} containerClass="carousel-container" removeArrowOnDeviceType={["tablet", "mobile", "desktop"]}>
                      {crypto.slice(0, 20).map((crypto, index) => (
                      <div className="mycard shadow p-3 me-3" style={{border:'1px solid #ffffff17'}}>
                        <div className="d-flex align-items-center">
                          <div className="d-flex align-items-center justify-content-center oveflow-hidden rounded-circle" style={{backgroundColor:'#ffffff17',height:'50px',width:'50px'}}>
                            <img src={crypto.logo} alt="BTC" style={{width: '30px'}}/>
                          </div>
                          <div className="ms-3">
                            <p className="mb-0 fw-semibold fs-5">{crypto.name} <span className="fs-6 ms-1 text-secondary" style={{fontSize:'14px'}}>[{crypto.symbol}]</span></p>
                            <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}><FontAwesomeIcon icon={faDotCircle} style={{fontSize: '12px'}} className="me-1" /> Main Coin</p>
                          </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mt-3">
                          <h3 className="mb-0 fw-semibold">US ${formatCurrency(crypto.price)}</h3>
                          <p className={`${crypto.percentage >= 0 ? 'text-success' : 'text-danger'} fw-semibold mb-0`}>
                            {crypto.percentage >= 0 ? '+' : ''}{crypto.percentage?.toFixed(2)}%
                          </p>
                        </div>
                      </div>
                      ))}
                    </Carousel>
                </div>
              </div>
              <div className="col-12">
                <div className="mycard mt-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center rounded-3 bg-prime px-3 py-1" style={{cursor:'pointer'}}>
                      <p className="mb-0 fw-semibold me-3" style={{fontSize: '14px'}}><FontAwesomeIcon icon={faFire} className="text-white" style={{fontSize: '14px'}} /> Trending</p>
                      <div 
                        className="px-2 py-1 rounded-2 fw-semibold me-2"
                        style={{
                          backgroundColor: trending === 5 ? '#ffffff' : '#01010145',
                          color: trending === 5 ? '#000000' : '#ffffff',
                          fontSize: '14px'
                        }}
                        onClick={() => setTrending(5)}
                      >
                        5M
                      </div>
                      <div 
                        className="px-2 py-1 rounded-2 fw-semibold me-2"
                        style={{
                          backgroundColor: trending === 1 ? '#ffffff' : '#01010145',
                          color: trending === 1 ? '#000000' : '#ffffff',
                          fontSize: '14px'
                        }}
                        onClick={() => setTrending(1)}
                      >
                        1H
                      </div>
                      <div 
                        className="px-2 py-1 rounded-2 fw-semibold me-2"
                        style={{
                          backgroundColor: trending === 6 ? '#ffffff' : '#01010145',
                          color: trending === 6 ? '#000000' : '#ffffff',
                          fontSize: '14px'
                        }}
                        onClick={() => setTrending(6)}
                      >
                        6M
                      </div>
                      <div 
                        className="px-2 py-1 rounded-2 fw-semibold me-2"
                        style={{
                          backgroundColor: trending === 24 ? '#ffffff' : '#01010145',
                          color: trending === 24 ? '#000000' : '#ffffff',
                          fontSize: '14px'
                        }}
                        onClick={() => setTrending(24)}
                      >
                        24H
                      </div>
                    </div>
                    <div className="d-md-flex d-none align-items-center" style={{gap:'5px'}}>
                      <div className="d-flex align-items-center justify-content-center rounded-circle" style={{backgroundColor:'#ffffff17', width:'30px',height:'30px'}}>
                        <FontAwesomeIcon icon={faMagnifyingGlass} style={{fontSize: '14px'}} />
                      </div>
                      <div className="d-flex align-items-center justify-content-center rounded-circle" style={{backgroundColor:'#ffffff17', width:'30px',height:'30px'}}>
                        <FontAwesomeIcon icon={faFilter} style={{fontSize: '14px'}} />
                      </div>
                      <div className="d-flex align-items-center justify-content-center rounded-circle" style={{backgroundColor:'#ffffff17', width:'30px',height:'30px'}}>
                        <FontAwesomeIcon icon={faGear} style={{fontSize: '14px'}} />
                      </div>
                      <div className="rounded-pill d-flex align-items-center px-3 py-1" style={{backgroundColor:'#ffffff17'}}>
                        <FontAwesomeIcon icon={faBolt} style={{fontSize: '12px'}} /> <p className="fw-semibold ms-1 mb-0" style={{fontSize: '13px'}}>12</p> </div>
                    </div>
                  </div>
                  <div className="row">
                    {newCrypto.slice(0, 12).map((newcrypto, index) => (
                    <div className="col-xxl-3 col-lg-4 col-md-6 g-2" key={index}>
                      <a href={`/coindetails?symbol=${encodeURIComponent(newcrypto.symbol)}`} className="d-flex align-items-center justify-content-between p-2 rounded-3 mycard noLink" style={{border:'1px solid #ffffff17'}}>
                        <div className="d-flex align-items-center">
                          <div className="rounded-3 d-flex align-items-center justify-content-center p-1 position-relative" style={{width:'40px',height:'40px',background: 'linear-gradient(to top, #009bfca1  5%, #00000013 95%)'}}>
                            <img src={newcrypto.logo} alt="image" style={{width:'80%',height:'80%',objectFit:'cover'}}/>
                            <img src={newcrypto.platform} alt="image" style={{width:'15px',height:'15px', bottom:'0px', right:'0px'}} className="rounded-circle position-absolute"/>
                          </div>
                          <div className="ms-2">
                            <p className="mb-0 fw-semibold" style={{lineHeight:'125%',fontSize:'14px'}}>{newcrypto.name} <span className="text-secondary ms-1 fw-semibold" style={{fontSize:'12px'}}>/ {newcrypto.symbol}</span></p>
                            <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'12px',lineHeight:'125%'}}>Mkt Cap: {formatLargeNumber(newcrypto.market_cap)}</p>
                            <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'12px',lineHeight:'125%'}}><span>Vol: {formatLargeNumber(newcrypto.volume)}</span> <span className="mx-2">-</span> <span>Supply: {formatLargeNumber(newcrypto.circulating_supply)}</span></p>
                          </div>
                        </div>
                        <div className="text-end">
                          <div className="rounded-4 px-1 d-inline-block fw-semibold mb-1" style={{fontSize:'10px', backgroundColor:'#009bfcff'}}><FontAwesomeIcon icon={faBolt} style={{color: 'white', fontSize: '8px'}}/> New</div>
                          <p className="mb-0 fw-semibold text-white" style={{fontSize:'12px',lineHeight:'125%'}}><span>{getCurrencySymbol(user?.currency)}{formatCurrency(newcrypto.price)}</span>(<span className={`${newcrypto.percent > 0 ?'text-success':'text-danger'}`}>{formatCurrency(newcrypto.percent)}%</span>)</p>
                        </div>
                      </a>
                    </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="d-flex align-items-center mt-4">
                  <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Recommended coins for 24 hours </p>
                  <FontAwesomeIcon className="ms-2 text-prime" icon={faClock} style={{fontSize: '14px'}} />
                  <span className="rounded-3 ms-3 px-2 py-1" style={{fontSize:'12px', backgroundColor:'#ff6b353d'}}>3 Assets</span>
                </div>
                <h1 className="mb-0 fe-semibold">Top Staking Assets</h1>
                <div className="row">
                  {stakes.map((stake) => (
                  <div className="col-xxl-3 col-lg-4 col-md-6 g-4">
                    <div className="mycard shadow p-3" style={{border:'1px solid #ffffff17'}}>
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                          <div className="d-flex align-items-center justify-content-center oveflow-hidden rounded-2" style={{backgroundColor:'#ffffff17',height:'40px',width:'40px'}}>
                            <img src={stake.logo} alt="BTC" style={{width: '25px'}}/>
                          </div>
                          <div className="ms-2">
                            <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>Proof of Stake</p>
                            <p className="mb-0 fw-semibold">{stake.name} [{stake.symbol}]</p>
                          </div>
                        </div>
                        <Link to="/stake" className="rounded-circle d-flex align-items-center justify-content-center" style={{border:'2px solid #ffffff17', width:'35px', height:'35px'}}>
                          <i data-feather="arrow-up-right" className="text-prime" height="18"></i>
                        </Link>
                      </div>
                      <p className="mb-0 text-secondary fw-semibold mt-4" style={{fontSize:'14px'}}>Reward Rate</p>
                      <h1 className="mb-0 fw-semibold">{Number(stake.roi).toFixed(2)}%</h1>
                      <p className="mb-0 text-success fw-semibold" style={{fontSize:'14px'}}>Daily</p>
                    </div>
                  </div>
                  ))}
                </div>
              </div>
              <div className="col-12">
                <div className="mycard mt-2">
                  <div className="row">
                    {newList.map((data, index) => {
                    const maxWords = 15;
                    const words = data.title?.split(" ") || [];
                    const shortTitle = words.length > maxWords 
                      ? words.slice(0, maxWords).join(" ") + "..." 
                      : data.title;
                    return (
                    <div className="col-xxl-3 col-lg-4 col-md-6 mb-4" key={index}>
                      <div className="d-flex align-items-center justify-content-center overflow-hidden rounded-4" style={{height:'200px',width:'100%',border:'2px solid #ffffff17'}}>
                        <img src={data.image} alt="image" style={{width:'100%',height:'100%',objectFit:'cover'}}/>
                      </div>
                      <h6 className="mb-2 fw-bold mt-3">{shortTitle}</h6>
                      <div className="d-flex align-items-center">
                        <p className="mb-0 text-secondary" style={{fontSize:'14px'}}><FontAwesomeIcon className="me-2 text-secondary" style={{fontSize:'14px'}} icon={faUser} /> {data.source_name.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())}</p>
                        <FontAwesomeIcon className="text-secondary mx-3" style={{fontSize:'8px'}} icon={faCircle} />
                        <p className="mb-0 text-secondary" style={{fontSize:'14px'}}><FontAwesomeIcon className="me-2 text-secondary" style={{fontSize:'14px'}} icon={faCalendarDays} /> {data.date}</p>
                      </div>
                    </div>
                    );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      <ConnectBar toggleConnectBar={toggleConnectBar} connectBar={connectBar}/>
      <Modal
          isOpen={modalIsOpen}
          onRequestClose={() => setIsOpen(false)}
          shouldCloseOnOverlayClick={true} 
          closeTimeoutMS={100}
          className="shortmode1"
      >
          <div className="d-flex align-items-center justify-content-between">
              <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Assets Preview</p>
              <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
          </div>
          <p className="my-2 text-light fw-semibold" style={{fontSize: '15px'}}>Add an asset that will be directly visible on your home dashboard</p>
          <div className="form-control justify-content-between py-1 pe-1">
            <input 
              type="search" 
              placeholder="Search Assets"
              className="inputNone w-100"
              value={coinListSearch}
              onChange={(e) => setCoinListSearch(e.target.value)}
            />
          </div>
          <div className="d-flex align-items-center assetScroll mt-2" style={{gap:'5px'}}>
            {sortedCoins.map((coin, index) => (
              <AssetList
                key={index}
                coin={coin}
                sideAssets={sideAssets}
                setSideAssets={setSideAssets}
              />
            ))}
            {sortedCoins.length === 0 && (
              <div className="text-muted py-3" style={{fontSize: 12}}>
                No coins match “{coinListSearch}”.
              </div>
            )}
          </div>
          <div className="myBtn w-100 text-center mt-3" style={{ paddingTop: '12px', paddingBottom: '12px' }} onClick={AddAsset}>
            {loading? <FontAwesomeIcon icon={faCircleNotch} style={{ fontSize: '20px', color: 'white', opacity: 0.5 }} spin /> : 'Save'}
          </div>
      </Modal>
    </div>
  )
}

export default Dashboard